import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { t } from '../../common/Translate';
import { useGuaranteedPrice } from '../../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import CounterAppraisalWhenPriceModified from './CounterAppraisalWhenPriceModified';
import GuranteedPriceProcess from './GuranteedPriceProcess';
import { NRM_SUB_STATUS } from '../../../config';
import { currencySign } from '../../../Utils/currencySign';

function CounterAppraisal({ recordId }) {
  const { guaranteedPrice, nrmStatusId, cancelCaseId, counterInspection } = useGuaranteedPrice(recordId);
  const {
    tradeInMaintainedPriceModified,
    finalizationCompleted,
    tradeInCancelled,
    tradeInMaintainedPriceMaintained,
    finalizationAccepted,
  } = NRM_SUB_STATUS;
  return (
    <>
      {(([tradeInMaintainedPriceModified, tradeInCancelled].includes(nrmStatusId) && cancelCaseId !== 1) ||
        ([finalizationCompleted, finalizationAccepted].includes(nrmStatusId) &&
          guaranteedPrice.maintainedGuaranteedAccepted !== null)) && (
        <>
          {nrmStatusId === tradeInCancelled && cancelCaseId === 4 ? (
            <span className="ml-2">{t('messageTradeInCanceledCounterInspectionOutdated')}</span>
          ) : (
            <CounterAppraisalWhenPriceModified recordId={recordId} />
          )}
          {[tradeInMaintainedPriceModified].includes(nrmStatusId) &&
            guaranteedPrice.maintainedGuaranteedAccepted === null && <GuranteedPriceProcess />}
        </>
      )}
      {guaranteedPrice.maintainedGuaranteedAccepted && (
        <span className="ml-2 font-weight-bold">{t('messageTradeInAcceptedPriceModified')}</span>
      )}
      {guaranteedPrice.maintainedGuaranteedAccepted === false &&
        [finalizationCompleted, tradeInCancelled].includes(nrmStatusId) && (
          <span className="ml-2 font-weight-bold">{t('messageTradeInDeclinedPriceModified')}</span>
        )}
      {(nrmStatusId === tradeInMaintainedPriceMaintained ||
        ([finalizationCompleted, finalizationAccepted].includes(nrmStatusId) &&
          guaranteedPrice.maintainedGuaranteedAccepted === null) ||
        (nrmStatusId === tradeInCancelled && cancelCaseId === 1)) && (
        <div>
          <div className="m-2">
            <span>{t('theTradeInHasBeenConfirmed')} : </span>
            <span>
              {guaranteedPrice?.guaranteeablePriceCounterDate?.date
                ? moment(guaranteedPrice.guaranteeablePriceCounterDate.date).format('DD/MM/YYYY')
                : moment(counterInspection?.createdAt?.date).format('DD/MM/YYYY')}
            </span>
          </div>
          {guaranteedPrice?.guaranteeablePriceCounter && (
            <div className="m-2">
              <span>{t('tradeInConfirmedAfterSecondInspection')} : </span>
              <span className="font-weight-bold">{currencySign(guaranteedPrice?.guaranteeablePriceCounter)}</span>
            </div>
          )}
        </div>
      )}{' '}
    </>
  );
}

CounterAppraisal.propTypes = {
  recordId: PropTypes.string.isRequired,
};

export default CounterAppraisal;
